/**
 * Ouvre ou télécharge un PDF reçu en Blob de manière compatible avec tous
 * les navigateurs — y compris iOS Safari / PWA où `window.open(blobUrl)` est
 * bloqué par le popup blocker quand appelé après un `await`.
 *
 * @param {Blob} blob         Le Blob PDF reçu depuis axios { responseType: 'blob' }
 * @param {string} filename   Nom de fichier (ex: "Fiche_Inscription_Konrady.pdf")
 * @param {'view'|'download'} mode  'view' = ouvrir dans un nouvel onglet, 'download' = forcer le téléchargement
 */
export function openPdfBlob(blob, filename = 'document.pdf', mode = 'view') {
  if (!(blob instanceof Blob)) return;

  // Forcer le type MIME pour que le navigateur sache le rendre inline
  const pdfBlob = blob.type === 'application/pdf'
    ? blob
    : new Blob([blob], { type: 'application/pdf' });

  const url = window.URL.createObjectURL(pdfBlob);

  const a = document.createElement('a');
  a.href = url;
  a.rel = 'noopener';

  if (mode === 'download') {
    a.setAttribute('download', filename);
  } else {
    // Mode view : l'attribut target ouvre un onglet dédié. iOS rend le PDF en inline.
    a.target = '_blank';
  }

  document.body.appendChild(a);
  a.click();
  a.remove();

  // Laisser le temps au navigateur d'amorcer le téléchargement / l'ouverture
  setTimeout(() => window.URL.revokeObjectURL(url), 1500);
}
